<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}
.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}
.monitorProduction .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}
.monitorProduction .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorProduction .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>

<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="padding: 34px 34px  0px  34px;">
        <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 440px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" src="../../../../assets/img/web/workshop/logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">{{ store.state.customer.shortName }}-{{ $t('shengchanjindujiankong') }}</div>
          <div class="monitorProduction" style="width: 440px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
            <div style="display: flex;align-items: center;">
              <yi_data_select :type="'organization'" :ids.sync="orgId"> </yi_data_select>
              <el-link @click="showCustomProduction()" style="color:#419FFF ;margin-left: 6px;font-size: 12px;" icon="yicon yicon-pencil">
                {{ $t('zidingyijihuachanliang') }}
              </el-link>
              <el-link @click="showBoardEdit()" style="color:#419FFF ;margin-left: 12px;font-size: 12px;" icon="yicon yicon-pencil">
                {{ $t('bianjikanban') }}
              </el-link>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item :refs="'grid_' + item.i" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component v-bind:is="item.i" :orgId="orgId"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>

    <el-dialog :show-close="true" :title="$t('kanpanshezhi')" :visible.sync="isShowBoardEdit" :close-on-click-modal="false" width="874px" append-to-body>
      <div class="dialog-scroller">
        <setting ref="setting"></setting>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowBoardEdit = false">{{ $t('quxiao') }}</el-button>
        <el-button
          size="mini"
          @click="
            $refs.setting.save();
            isShowBoardEdit = false;
          "
          type="primary"
        >
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="true" :title="$t('zidingyijihuachanliang')" :visible.sync="isShowCustomProduction" :close-on-click-modal="false" width="600px" append-to-body>
      <div class="dialog-scroller">
        <custom_production v-if="isShowCustomProduction" ref="custom_production"></custom_production>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowCustomProduction = false">{{ $t('quxiao') }}</el-button>
        <el-button
          size="mini"
          @click="
            $refs.custom_production.batchCreateOrUpdate();
            isShowCustomProduction = false;
          "
          type="primary"
        >
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';
import row from '@@/pages/web/monitor/production/row';
import setting from '@@/pages/web/monitor/production/setting';
import custom_production from '@@/pages/web/monitor/production/custom_production';

export default {
  name: 'web_monitor_production_index',
  components: {
    custom_production: custom_production,
    setting: setting,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    row: row
  },

  data() {
    return {
      isShowCustomProduction: false,
      isShowBoardEdit: false,
      orgId: this.store.state.organizations[0].id,
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      show: 'row', //row,card
      layout: [
        {
          x: 0,
          y: 0,
          w: 24,
          h: 24, //应该是6
          i: ''
        }
      ]
    };
  },

  created() {
    this.utils.event_hub.$emit('TOGGLE_TABBAR', true);
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.show = 'row';
    this.layout[0].i = this.show;
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {},
  methods: {
    showCustomProduction() {
      this.isShowCustomProduction = true;
      this.$nextTick(() => {
        this.$refs.setting.resetData();
      });
    },
    showBoardEdit() {
      this.isShowBoardEdit = true;
      this.$nextTick(() => {
        this.$refs.setting.resetData();
      });
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
      }, 500);
    }
  }
};
</script>
